"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Grid = _interopRequireDefault(require("../common/Grid/Grid"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Container = function Container(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className,
    bgColor = _ref.bgColor,
    fullWidth = _ref.fullWidth;
  var styles = {
    container: {
      maxWidth: '600px',
      margin: '0 auto',
      fontFamily: 'Backpack, Helvetica Neue, Helvetica, Arial, sans-serif',
      backgroundColor: _userflow["default"].colors.concrete
    },
    cell: {
      padding: fullWidth ? 0 : '0 10px'
    },
    block: {
      background: bgColor || 'none',
      fontSize: 0
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "container ".concat(className, " ").concat(fullWidth ? 'container--without-padding' : ''),
    style: styles.container,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: _objectSpread(_objectSpread({}, styles.cell), style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.block), style)
  }, children)));
};
Container.defaultProps = {
  style: {},
  className: '',
  bgColor: '',
  fullWidth: false
};
Container.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  fullWidth: _propTypes["default"].bool
};
var _default = exports["default"] = Container;